module.exports = __webpack_public_path__ + "static/media/fresh-leaves.d5f33dce.png";